import React from 'react'
import { SocialMediaList } from './list/page'

export const SocialMediaPage: React.FC = () => {
  return <SocialMediaList />
}
